import React, { useRef } from 'react';

const Ripple = ({ 
  mainCircleSize = 210,
  numCircles = 8,
  opacity = 0.55,
  className = ''
}) => {
  const containerRef = useRef(null);

  return (
    <div 
      ref={containerRef}
      className={`absolute inset-0 flex items-center justify-center overflow-hidden ${className}`}
      style={{ zIndex: 0, opacity }}
    >
      <div className="relative flex items-center justify-center">
        {Array.from({ length: numCircles }).map((_, i) => {
          const delay = i * 0.5;
          const scale = 1 + (i * 0.5);
          
          return (
            <div
              key={i}
              className="absolute rounded-full border animate-ripple pointer-events-none"
              style={{
                width: `${mainCircleSize}px`,
                height: `${mainCircleSize}px`,
                animationDelay: `${delay}s`,
                transform: `scale(${scale})`,
                opacity: 0,
                borderWidth: '2px',
                borderColor: 'currentColor',
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Ripple;
